import { inject } from '@angular/core';
import {
  ApolloClientOptions,
  ApolloLink,
  InMemoryCache,
} from '@apollo/client/core';
import { provideApollo } from 'apollo-angular';
import { HttpLink } from 'apollo-angular/http';
import { setContext } from '@apollo/client/link/context';
import { environment } from 'src/environments/environment';
import { onError } from '@apollo/client/link/error';
import { Router } from '@angular/router';
import Swal from 'sweetalert2';

const uri = environment.bifrostUrl;

export function createApollo(

): ApolloClientOptions {
  const httpLink = inject(HttpLink);
  const router = inject(Router);

  const errorLink = onError(({ error }) => {

    const networkError = error as any;

    // Código comentado para uso futuro
    // Esse if consegue tratar todos os erros graphql sem precisar ser chamado nos
    // componentes, seria bom alterar o tratamento de erros atual que usa o error-lib.service
    // if (graphQLErrors) {
    //   for (const err of graphQLErrors) {
    //     const msg = err.message?.toLowerCase() || '';
    //     if (msg.includes('erro 1') || msg.includes('erro 2')) {
    //       router.navigate(['/login']);
    //     }
    //   }
    // }

    // Erros de rede (Caso seja necessário adicionar um ID de erro novo adicionar abaixo)
    if (networkError) {
      // Para token invalido o bifrost retorna 401
      if (networkError.status === 401) {
        Swal.fire({
          title: 'Acesso bloqueado!',
          text: 'Seu token de acesso expirou, para continuar acessando o sistema faça login novamente!',
          icon: 'error',
          timer: 5000,
          showConfirmButton: true,
        }).then(() => {
          router.navigate(['/login']);
        });
      }
    }
  });

  const authLink = setContext((operation) => {
    const token = localStorage.getItem('token');

    const headers: any = {
      Accept: 'charset=utf-8',
    };

    // Não envia token no login
    if (
      token &&
      !operation.operationName?.toLowerCase().includes('login')
    ) {
      headers.Authorization = `Bearer ${token}`;
    }

    return { headers };
  });

  const link = ApolloLink.from([
    errorLink,
    authLink,
    httpLink.create({ uri }),
  ]);

  return {
    link,
    cache: new InMemoryCache(),
  };
}
export const graphqlProviders = [
  provideApollo(createApollo),
];

